const seminarTypes = {
  1: {
    shortName: 'Level 1',
    name: 'Level 1 Certificate Course',
    seminarType: 'level-one',
    metaType: 'level1',
    dailyListShortName: 'L1 Course',
    urlBase: '/certificate-courses/level-1',
  },
  56: {
    shortName: 'Level 1',
    name: 'Online Level 1 Certificate Course',
    seminarType: 'online-level-one',
    metaType: 'onlinelevel1',
    dailyListShortName: 'L1 Course',
    urlBase: '/certificate-courses/online-level-1',
  },
  // 3: {
  //   shortName: 'CrossFit Trainer',
  //   longName: 'Certified CrossFit Trainer',
  //   seminarType: 'certified-crossfit-trainer', // TODO url parse full path: crossfit.com/certifications/certified-crossfit-trainer
  // },
  // 51: {
  //   shortName: 'CCFC',
  //   longName: 'Certified CrossFit Coach',
  //   seminarType: 'certified-crossfit-coach', // TODO url parse full path: crossfit.com/certifications/certified-crossfit-coach
  // },
  5: {
    shortName: 'Level 2',
    longName: 'Level 2 Certificate Course',
    seminarType: 'level-two',
    metaType: 'level2',
    dailyListShortName: 'L2 Course',
    urlBase: '/certificate-courses/level-2',
  },

  // 13: {
  //   shortName: 'Kids',
  //   longName: 'CrossFit Specialty Course: Kids',
  //   seminarType: 'kids',
  //   metaType: 'kids',
  // },
  57: {
    shortName: 'Kids',
    name: 'Online Kids Certificate Course',
    seminarType: 'online-kids',
    metaType: 'onlinekids',
    dailyListShortName: 'Kids Course',
    urlBase: '/certificate-courses/online-kids',
  },
  // 45: {
  //   shortName: 'Educators',
  //   longName: 'CrossFit Specialty Course: Educators',
  //   seminarType: 'educators',
  // },
}

// const seminarNames = {
//   2: {
//     name: 'Level 1 UNTESTED',
//   },
//   3: {
//     name: 'Level 2 UNTESTED',
//   },
//   4: {
//     name: 'Level 3 UNTESTED',
//   },
//   7: {
//     name: 'CrossFit Specialty Course: Advanced Gymnastics',
//   },
//   8: {
//     name: 'CrossFit Specialty Course: SPEAR&#153; Science of Self-Defense',
//   },
//   10: {
//     name: 'CrossFit Specialty Course: Sport-Specific Application',
//   },
//   11: {
//     name: 'CrossFit Specialty Course: Gymnastics',
//     url: 'https://training.crossfit.com/gymnastics',
//   },
//   12: {
//     name: 'CrossFit Specialty Course: Kettlebell',
//     url: 'https://training.crossfit.com/kettlebell',
//   },
//   13: {
//     name: 'Kids Certificate Course',
//     shortName: 'Kids Course',
//     url: '/certificate-courses/kids',
//   },
//   14: {
//     name: 'CrossFit Specialty Course: Mobility',
//   },
//   15: {
//     name: 'CrossFit Specialty Course: Weightlifting',
//     url: 'https://training.crossfit.com/weightlifting',
//   },
//   16: {
//     name: 'CrossFit Specialty Course: Conjugate Methods',
//     url: 'https://training.crossfit.com/conjugate-methods',
//   },
//   17: {
//     name: 'CrossFit Specialty Course: Rowing (Water and Erg)',
//   },
//   18: {
//     name: 'CrossFit Workshop: Striking',
//   },
//   19: {
//     name: 'CrossFit Specialty Course: Strongman',
//   },
//   21: {
//     name: 'CrossFit Specialty Course: Endurance Athlete',
//   },
//   22: {
//     name: 'CrossFit Specialty Course: Competitors',
//   },
//   23: {
//     name: 'CrossFit Online Course: Judges',
//   },
//   24: {
//     name: 'CrossFit Specialty Course: Weightlifting Level 2',
//     url: 'https://training.crossfit.com/weightlifting-level-two',
//   },
//   25: {
//     name: 'CrossFit Specialty Course: Rowing (Erg)',
//     url: 'https://training.crossfit.com/rowing-one-day',
//   },
//   26: {
//     name: 'CrossFit Online Course: Scaling',
//   },
//   27: {
//     name: 'CrossFit Specialty Course: Aerobic Capacity',
//     url: 'https://training.crossfit.com/aerobic-capacity',
//   },
//   28: {
//     name: 'CrossFit Specialty Course: Culinary Ninja',
//   },
//   29: {
//     name: 'CrossFit Workshop: Running',
//   },
//   30: {
//     name: 'CrossFit Specialty Course: Law Enforcement Application',
//   },
//   31: {
//     name: 'CrossFit Online Course: Anatomy',
//   },
//   32: {
//     name: 'CrossFit Specialty Course: Adaptive Training',
//     url: 'https://training.crossfit.com/adaptive-training',
//   },
//   33: {
//     name: 'CrossFit Curso Online: Curso de AdaptaÃ§Ã£o',
//   },
//   34: {
//     name: 'CrossFit Curso En Linea: Curso de Escalamiento',
//   },
//   35: {
//     name: 'CrossFit Online Course: Spot the Flaw',
//   },
//   36: {
//     name: 'CrossFit Specialty Course: Masters (Two-Day Course)',
//   },
//   37: {
//     name: 'CrossFit Workshop: Flexibility',
//   },
//   38: {
//     name: 'CrossFit Workshop: Dumbbell',
//   },
//   40: {
//     name: 'CrossFit Coaches Development Program',
//   },
//   41: {
//     name: 'CrossFit Workshop: Be Your Own Bodyguard',
//   },
//   42: {
//     name: 'CrossFit Online Course: Running',
//   },
//   43: {
//     name: 'CrossFit Workshop: Culinary Ninja',
//   },
//   44: {
//     name: 'CrossFit Online Course: Lesson Planning',
//   },
//   45: {
//     name: 'CrossFit Specialty Course: Educators',
//   },
//   46: {
//     name: 'CrossFit Workshop: Jump Rope',
//   },
//   47: {
//     name: 'CrossFit Specialty Course: Pose Running',
//   },
//   48: {
//     name: 'CrossFit Specialty Course: Masters',
//     url: 'https://training.crossfit.com/masters',
//   },
//   49: {
//     name: 'CrossFit Workshop: Advanced Gymnastics Skills',
//     url: 'https://training.crossfit.com/gymnastics',
//   },
//   50: {
//     name: 'CrossFit Online Course: Judges 2019 English',
//   },
//   51: {
//     name: 'Certified CrossFit Coach Evaluation',
//     shortName: 'CCFC Evaluation',
//     url: 'https://certifications.crossfit.com/ccfc',
//   },
//   52: {
//     name: `Cours en Ligne L'adaptation`,
//   },
// }
export default seminarTypes
